import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { PriceConverter } from '../../../helpers'

import { getPayablePerLabel } from '../helpers'

const PackageExtra = ({
  item,
  isInsurance,
  currency,
  selectedShop,
  showCourseDetails,
  selectedCurrency,
}) => {
  const { isIncluded, description, title, diveProductId } = item
  const extraValueTotal = `${item.quantity} x ${item.extraValue} *`
  const showPayablePerLabel =
    item.payedInAdvance && !isInsurance && !item.isCourse
  const convertToCurrency = item.payedInAdvance
    ? selectedCurrency
    : item.currency || currency
  const showInfo = () => showCourseDetails(diveProductId)
  return (
    <div className='price-pan__body__row'>
      <ReactTooltip effect='solid' type='dark' />
      <div className='title flex'>
        {isIncluded && <i className='font-icons check-icon' />}
        <span className='tooltip-wrapper-block' data-tip={description}>
          {title}
          {description && <i className='font-icons info-icon' />}
          {item.isCourse && (
            <p
              className='view-inclusions small link-color bold'
              onClick={showInfo}
            >
              <FormattedMessage
                id='view_inclusion_extras'
                defaultMessage='View inclusions & exclusions'
              />
              <i className='font-icons info-icon' />
            </p>
          )}
        </span>
      </div>

      <div className='quantity'>
        {(isInsurance || !isIncluded) && <span>{item.quantity}</span>}
      </div>

      {!isIncluded && !isInsurance && (
        <div className={`price ${!item.payedInAdvance ? 'gray' : ''}`}>
          <span>
            {!!+item.price && <small>{convertToCurrency}&nbsp;</small>}
            {+item.price ? (
              <PriceConverter
                amount={item.price}
                currency={currency}
                to={convertToCurrency}
                noCurrency
              />
            ) : (
              item.extraValue
            )}
            {showPayablePerLabel && (
              <small className='incl'>
                {getPayablePerLabel(item.payedPer, 1, selectedShop.shopKind)}
              </small>
            )}
          </span>
        </div>
      )}

      {isIncluded || isInsurance ? (
        <div className='total-price green'>
          <FormattedMessage id='included' defaultMessage='Included' />
        </div>
      ) : (
        <div className={`total-price ${!item.payedInAdvance ? 'gray' : ''}`}>
          <span>
            {!!+item.amount && <small>{convertToCurrency}&nbsp;</small>}
            {+item.amount ? (
              <PriceConverter
                amount={item.amount}
                currency={currency}
                to={convertToCurrency}
                noCurrency
              />
            ) : (
              extraValueTotal
            )}
          </span>
        </div>
      )}
    </div>
  )
}
export default connect((state) => ({
  selectedShop: state.selectedShop,
  selectedCurrency: state.selectedCurrency,
}))(PackageExtra)
